import { pWarn } from '_/helpers/logger'

import Vue from 'vue'

import { store } from '_/vuex/store'
import assetsManagerFactory from '_/vuex/modules/assetsManager'

import { mapGetters } from 'vuex'

import EasyMDE from 'easymde'

const AssetsManagerModal = Vue.component(
  'AssetsManagerModal',
  require('_/components/FieldTypes/AssetsManager/AssetsManagerModal/AssetsManagerModal.vue')
    .default
)

const InsertImageModal = Vue.component(
  'InsertImageModal',
  require('_/components/FieldTypes/Markdown/InsertImageModal/InsertImageModal.vue')
    .default
)

const InsertLinkModal = Vue.component(
  'InsertLinkModal',
  require('_/components/FieldTypes/Markdown/InsertLinkModal/InsertLinkModal.vue')
    .default
)
const HelpModal = Vue.component(
  'HelpModal',
  require('_/components/FieldTypes/Markdown/HelpModal/HelpModal.vue').default
)

export default {
  /**
   * Define props
   *
   * @type  {Object}
   */
  props: {
    defaultValue: {
      type: [Boolean, String],
    },
    accept: {
      type: String,
    },
    accesskey: {
      type: String,
    },
    align: {
      type: String,
    },
    alt: {
      type: String,
    },
    autocomplete: {
      type: Boolean,
    },
    autofocus: {
      type: Boolean,
    },
    checked: {
      type: Boolean,
    },
    dirname: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    form: {
      type: String,
    },
    formaction: {
      type: String,
    },
    formenctype: {
      type: String,
    },
    formmethod: {
      type: String,
    },
    formnovalidate: {
      type: Boolean,
    },
    formtarget: {
      type: String,
    },
    id: {
      required: true,
      type: [Number, String],
    },
    height: {
      type: String,
    },
    list: {
      type: String,
    },
    max: {
      type: Number,
    },
    maxlength: {
      type: Number,
    },
    min: {
      type: Number,
    },
    name: {
      required: true,
      type: String,
    },
    systemId: {
      type: [Number, String],
    },
    systemName: {
      type: String,
    },
    pattern: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    readonly: {
      type: Boolean,
    },
    refreshFields: {
      type: Number,
    },
    required: {
      type: Boolean,
    },
    size: {
      type: Number,
    },
    src: {
      type: String,
    },
    step: {
      type: Number,
    },
    tabindex: {
      type: Number,
    },
    type: {
      default: 'text',
      type: String,
    },
    value: {
      default: null,
      type: [Number, String],
    },
    width: {
      type: Number,
    },
    focus: {
      default: false,
      type: Boolean,
    },
  },

  /**
   * Set the component data
   *
   * @return  {object}
   */
  data: function() {
    return {
      multiple: false,
      easymde: {},
      showInsertImageModal: false,
      showInsertLinkModal: false,
      showHelpModal: false,
      selectedAsset: null,
    }
  },

  /**
   * Set the computed properties
   *
   * @type {object}
   */
  computed: {
    ...mapGetters({
      ui: 'ui/ui',
      admin: 'admin/admin',
    }),

    /**
     * Define the assetsManager getter
     *
     * @return  {object}
     */
    assetsManager() {
      const getterName = `${this.registeredModuleName}/${this.registeredModuleName}`

      return this.$store.getters[getterName]
    },

    /**
     * Gets the assets manager state
     *
     * @return  {boolean}
     */
    assetsManagerVisible() {
      return this.assetsManager.assetsManagerVisible
    },

    /**
     * Gets the registeredModuleName
     *
     * @return  {string}
     */
    registeredModuleName() {
      return `assetsManager-${this.name}-${this.id}-${Date.now()}`
    },
  },

  /**
   * Set the mounted hook
   *
   * @return  {void}
   */
  mounted() {
    this.$nextTick(() => {
      this.setDefaultValueIfRequired()

      this.initializeEasymde()

      this.initializeAssetManager()

      if (this.focus) {
        $(this.$el)
          .find('textarea')
          .focus()
      }
    })
  },

  /**
   * Sets a created hook
   *
   * @return  {void}
   */
  created: function() {
    this.createAssetManagerVuexModule()
  },

  /**
   * Set the methods
   *
   * @type  {Object}
   */
  methods: {
    /**
     * Create asset manager Vuex module
     *
     * @return  {void}
     */
    createAssetManagerVuexModule() {
      const assetsManagerDynamicModuleName = this.registeredModuleName
      if (!_.has(store.state, assetsManagerDynamicModuleName)) {
        store.registerModule(
          assetsManagerDynamicModuleName,
          assetsManagerFactory(assetsManagerDynamicModuleName)
        )
      }
    },
    /**
     * Initializes the asset manager
     *
     * @return  {void}
     */
    initializeAssetManager() {
      store.dispatch(`${this.registeredModuleName}/initializeState`, {
        multiple: this.multiple,
        value: this.value,
      })
    },

    /**
     * Emmits a change event with a payload consting of input value and the event object
     *
     * @param   {event}  event
     * @return  {void}
     */
    onChange: function(id, name, value) {
      this.$emit('change', {
        id,
        name,
        value,
      })
    },

    /**
     * Performs a series of actions on asset selection
     *
     * @return  {void}
     */
    onAssetSelection() {
      this.showInsertImageModal = true
      if (!_.isEmpty(this.assetsManager.selectedAssets)) {
        let asset = Object.assign({}, this.assetsManager.selectedAssets[0])
        this.selectedAsset = { ...asset }
      }
    },

    /**
     * Initializes the Redactor plug-in
     *
     * @return  {void}
     */
    initializeEasymde: function() {
      let self = this

      self.easymde = new EasyMDE({
        element: $(this.$el).find('textarea')[0],
        toolbar: [
          'bold',
          'italic',
          'strikethrough',
          'heading',
          '|',
          'quote',
          'code',
          'unordered-list',
          'ordered-list',
          '|',
          {
            name: 'image',
            action: function customFunction(editor) {
              self.openAssetsManager()
            },
            className: 'fal fa-image',
            title: 'Image',
          },
          {
            name: 'link',
            action: function customFunction(editor) {
              self.showInsertLinkModal = true
            },
            className: 'fal fa-link',
            title: 'Link',
          },
          '|',
          'side-by-side',
          'preview',
          'fullscreen',
          '|',
          {
            name: 'guide',
            action: function customFunction(editor) {
              self.showHelpModal = true
            },
            className: 'fal fa-question-circle',
            title: 'Guide',
          },
        ],
      })

      self.easymde.codemirror.on('change', () => {
        self.onChange(self.id, self.name, self.easymde.value())
      })
    },

    /**
     * Sets a component value to defaultValue, if required
     *
     * @return  {void}
     */
    setDefaultValueIfRequired() {
      if (this.defaultValue && this.admin.editorMode === 'create') {
        this.$emit('change', {
          id: this.id,
          name: this.name,
          value: this.defaultValue,
        })
      }
    },

    /**
     * Shows modal window
     *
     * @return  {void}
     */
    openAssetsManager() {
      store.dispatch(`${this.registeredModuleName}/initializeState`, {
        multiple: this.multiple,
        value: this.value,
      })

      store.dispatch(`${this.registeredModuleName}/assetsManagerVisible`, {
        value: true,
      })
    },

    /**
     * Close insert image modal event handler
     *
     * @return  {void}
     */
    onCloseInsertImageModal() {
      this.showInsertImageModal = false
    },

    /**
     * Close insert image modal with completed insertion event handler
     *
     * @param {Object} payload
     * @return  {void}
     */
    onFinsihedInsertImageModal(payload) {
      this.showInsertImageModal = false

      let { choosenSize, title } = payload
      let previewUrl = this.selectedAsset.fields.resized_images[choosenSize]
        .fields.file_url
      let imageTemplate = `![${title}](${previewUrl.replace(/\s/g, '&#32;')})`
      let oldValue = this.easymde.value()
      let newValue = oldValue + imageTemplate
      this.easymde.value(newValue)
    },

    /**
     * Close insert link modal event handler
     *
     * @return  {void}
     */
    onCloseInsertLinkModal() {
      this.showInsertLinkModal = false
    },

    /**
     * Close insert link modal with completed insertion event handler
     *
     * @param {Object} payload
     * @return  {void}
     */
    onFinsihedInsertLinkModal(payload) {
      this.showInsertLinkModal = false
      let { url, anchorText } = payload
      let linkTemplate = `[${anchorText}](${url})`
      let oldValue = this.easymde.value()
      let newValue = oldValue + linkTemplate
      this.easymde.value(newValue)
    },

    /**
     * Close modal modal event handler
     *
     * @return  {void}
     */
    onCloseHelpModal() {
      this.showHelpModal = false
    },
  },

  watch: {
    refreshFields(newEntry, oldEntry) {
      if (newEntry !== oldEntry) {
        pWarn(
          'Watched property fired.',
          `InputTag.${this.name}`,
          'refreshFields',
          newEntry,
          oldEntry,
          this
        )

        this.setDefaultValueIfRequired()

        let value = this.value ? this.value : ''

        this.easymde.value(value)

        this.$forceUpdate()

        if (this.focus) {
          $(this.$el)
            .find('textarea')
            .focus()
        }
      }
    },
  },
}
